import React from 'react';
import AsyncLoading from '@components/AsyncLoading/AsyncLoading';

const LeaveRequestsDetailsLazy = React.lazy(
	() =>
		import(
			/* webpackChunkName : 'LeaveRequestsDetails' */ './components/LeaveRequestsDetails'
		)
);

export default (store) => {
	return {
		path: ':excuseId',
		element: <AsyncLoading component={<LeaveRequestsDetailsLazy />} />,
	};
};
